import { faFolder } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from 'reactstrap';
import "./index.scss";
const Item = ({ item, __handleSelectedAction, type }) => {
	return (
		<>
			<Button
				color="link"
				className="text-start d-inline-flex align-items-center item"
				onClick={() => __handleSelectedAction(item?._source?.name, { _id: item?._id })}
				data-toggle="tooltip" data-placement="top" title={item?._source?.name}
			>
				<span className="icon d-inline-flex align-items-center justify-content-center rounded-circle">
					<FontAwesomeIcon icon={faFolder} />
				</span>
				<label>
					{type == 'folder' ? item?._source?.loan_number : item?._source?.name}
					{/*<span className="user-lbl d-block">
						{item?._source?.name}
					</span> */}
				</label>
			</Button>
		</>
	);
}

export default Item;